import { OneAlert } from '@factorialco/f0-react/dist/experimental'

import i18n from 'modules/core/lib/i18n'

interface Props {
  onView: () => void
}

export const DuplicateCandidatesAlert = ({ onView }: Props) => {
  return (
    <OneAlert
      variant="warning"
      title={i18n.t('ats.candidate_details.duplicated.alert')}
      description=""
      action={{
        label: i18n.t('ats.candidate_details.duplicated.action'),
        onClick: onView,
      }}
    />
  )
}
